import React from 'react';
import {Route} from "react-router-dom";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {useTranslation} from "react-i18next";
import BsPanel from "components/panel/BsPanel";
import LabelAdminInfoTab from "./tabs/info/LabelAdminInfoTab";
import LabelAdminSystemsTab from "./tabs/systems/LabelAdminSystemsTab";
import LabelAdminBicycleScanHistory from "./tabs/bicycle-scan-history/LabelAdminBicycleScanHistory";
import LabelAdminCustomerSupport from "./tabs/customer-support/LabelAdminCustomerSupport";

function LabelAdminInfo(props) {
  const lastSegment = props.location.pathname.replace(props.match.url, '').replace('/', '')
  const defaultTab = lastSegment.split('?')[0]
  const [value, setValue] = React.useState(defaultTab ? defaultTab : 'info');
  const {t} = useTranslation();

  const handleChange = (event, newValue) => {
    if (value !== newValue) {
      props.history.push((props.match.url + '/' + newValue).replace('//', '/'))
    }
    setValue(newValue);
  };

  return (
      <BsPanel>
        <Tabs value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary">
          <Tab label={t('admin_info.info_tab')} value="info"/>
          <Tab label={t('admin_info.systems_tab')} value="systems"/>
          <Tab label={t('admin_info.scan_history_tab')} value="scan-history"/>
          <Tab label={t('admin_info.customer_support_tab')} value="reported-problems"/>
        </Tabs>

        <Route exact path="/label/:labelId/admin/:userId" component={LabelAdminInfoTab}/>
        <Route path="/label/:labelId/admin/:userId/info" component={LabelAdminInfoTab}/>
        <Route path="/label/:labelId/admin/:userId/systems" component={LabelAdminSystemsTab}/>
        <Route path="/label/:labelId/admin/:userId/scan-history" component={LabelAdminBicycleScanHistory}/>
        <Route path="/label/:labelId/admin/:userId/reported-problems" component={LabelAdminCustomerSupport}/>
      </BsPanel>
  );
}

export default LabelAdminInfo;
